<template>
    <v-dialog v-model="dialog" content-class="branded-loader-dialog" full-width persistent>
        <v-row class="layout align-center justify-center column fill-height">
            <gears-loader :color="color" />
            <p class="branded-loader-message">
                {{ message }}
                <animated-dots />
            </p>
        </v-row>
    </v-dialog>
</template>

<script>
    import AnimatedDots from '@/components/globals/AnimatedDots.vue';
    import GearsLoader from '@/components/globals/GearsLoader.vue';

    export default {
        components: {
            AnimatedDots,
            GearsLoader,
        },
        props: {
            active: {
                type: Boolean,
                required: true,
            },
            message: {
                type: String,
                default: 'Initializing BuyerBridge',
            },
            color: {
                type: String,
                default: '#42A5F5',
            },
        },
        data() {
            return {
                dialog: false,
            };
        },
        watch: {
            active(isActive) {
                this.dialog = isActive;
            },
        },
        mounted() {
            this.dialog = this.active;
        },
    };
</script>

<style lang="scss">
    .branded-loader-message {
        color: white;
    }
</style>
